import React from 'react';

const SendIcon = ({ className }) => (
  <svg className={className} width="53" height="54" viewBox="0 0 53 54" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="icon-share">
      <path id="Vector" d="M2.71662 31.5939L13.3052 37.3049L31.847 22.156L14.6754 44.0524V52.2621L22.4053 41.9976L34.7037 48.7159C35.3106 49.0477 36.0402 49.0681 36.6649 48.7708C37.2892 48.4735 37.7323 47.8947 37.8555 47.215L45.2633 6.47266L2.773 27.7764C2.29881 28.0116 1.92848 28.413 1.73209 28.9036C1.53612 29.3942 1.52816 29.94 1.70972 30.4363C1.89129 30.9326 2.24987 31.3445 2.71648 31.5938L2.71662 31.5939Z" fill="currentColor"/>
    </g>
  </svg>
);

export default SendIcon;